import { render, staticRenderFns } from "./clinicalDetail.vue?vue&type=template&id=316d9dbe&scoped=true"
import script from "./clinicalDetail.vue?vue&type=script&lang=js"
export * from "./clinicalDetail.vue?vue&type=script&lang=js"
import style0 from "./clinicalDetail.vue?vue&type=style&index=0&id=316d9dbe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d9dbe",
  null
  
)

export default component.exports